import { useRefreshTokensMutation } from '../../services/authService/__generated__/queries.generated';
import { useSnapshot } from 'valtio';
import { authStore } from '../../../store/authStore';
import styled from 'styled-components';
import tw from 'twin.macro';

export default function TestPage() {
  const { tokens } = useSnapshot(authStore);
  const [testRefreshTokens] = useRefreshTokensMutation({
    variables: {
      refreshToken: tokens.refreshToken ?? '',
    },
  });
  return (
    <div>
      <button onClick={() => testRefreshTokens()}>Test Refresh Tokens</button>
    </div>
  );
}
